import Axios from 'axios';
import { IResult } from '../data/data';
import { IToken, TokenRequestError, TokenCache, TokenRequest } from 'pintra-fx';
import { IEnv } from '../store';

export class SharePointService {
  public static async fetch(env: IEnv, query: string, page: number) {
    let pageSize =
      env.props.pageSize && env.props.pageSize.length > 0
        ? parseInt(env.props.pageSize)
        : 10;
    let startRow = page * pageSize - pageSize;
    let selectProperties =
      "&selectproperties='HitHighlightedSummary,Author,Title,Description,Path,ContentClass,FileExtension,LastModifiedTime,IsDocument,ContentTypeId'";

    let home =
      env.props.home && env.props.home.length > 0 ? env.props.home : '';

    const tokenResponse: IToken | TokenRequestError = await TokenCache.getToken(
      new TokenRequest('sharepoint', env.props.resource),
      {
        wpAjaxAdminUrl: env.wpAjaxAdminUrl,
        nonce: env.nonce
      }
    );

    if (tokenResponse instanceof Error) {
      return new Error('Unexpected: Could not retrieve a valid access token.');
    }

    const token = <IToken>tokenResponse;

    const response = await Axios.get(
      `${home}/_api/search/query?querytext='${query}'${selectProperties}&startrow=${startRow}&rowlimit=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${token.bearer}`,
          Accept: 'application/json;odata=verbose'
        }
      }
    );

    return SharePointService.searchResultsConverter(response);
  }

  public static searchResultsConverter(result: any): IResult[] {
    try {
      return result.data.d.query.PrimaryQueryResult.RelevantResults.Table.Rows.results.map(
        (row: any) => {
          let objectified: any = {};

          row.Cells.results.map((item: any) => {
            objectified[(<string>item['Key']).toLowerCase()] = item['Value'];
          });

          let isUser =
            SharePointService.hasProp(objectified, 'contentclass') &&
            objectified.contentclass.toLowerCase() ==
              'urn:content-class:spspeople';

          let result: IResult = {
            icon: '',
            title: SharePointService.hasProp(objectified, 'preferredname')
              ? objectified.preferredname
              : 'title' in objectified
              ? objectified.title
              : '',
            description:
              SharePointService.hasProp(objectified, 'description') &&
              objectified.description.length > 0
                ? objectified.description
                : SharePointService.hasProp(
                    objectified,
                    'hithighlightedsummary'
                  ) && objectified.hithighlightedsummary.length > 0
                ? objectified.hithighlightedsummary.replace(
                    /<\/?[^>]+(>|$)/g,
                    ''
                  )
                : '',
            primaryUser: SharePointService.hasProp(objectified, 'author')
              ? objectified.author
              : '',
            path: SharePointService.hasProp(objectified, 'path')
              ? objectified.path
              : '',
            fileExtension:
              SharePointService.hasProp(objectified, 'isdocument') &&
              objectified.isdocument &&
              SharePointService.hasProp(objectified, 'fileextension')
                ? objectified.fileextension
                : '',
            lastModified: SharePointService.hasProp(
              objectified,
              'lastmodifiedtime'
            )
              ? objectified.lastmodifiedtime
              : null,
            isWorkspace:
              SharePointService.hasProp(objectified, 'contentclass') &&
              (objectified.contentclass == 'STS_Site' ||
                objectified.contentclass == 'STS_Web')
                ? true
                : false,
            isDocument:
              SharePointService.hasProp(objectified, 'isdocument') &&
              objectified.isdocument &&
              SharePointService.hasProp(objectified, 'contenttypeid') &&
              (<string>objectified.contenttypeid).indexOf('0x0101', 0) >= 0
                ? true
                : false,
            isFolder:
              SharePointService.hasProp(objectified, 'contenttypeid') &&
              (<string>objectified.contenttypeid).indexOf('0x0120', 0) >= 0
                ? true
                : false,
            isList:
              SharePointService.hasProp(objectified, 'contentclass') &&
              objectified.contentclass.indexOf('STS_List_', 0) >= 0
                ? true
                : false,
            isNewsFeed:
              SharePointService.hasProp(objectified, 'path') &&
              objectified.path.indexOf('newsfeed.aspx', 0) >= 0
                ? true
                : false,
            isUser: SharePointService.hasProp(objectified, 'accountname'),
            selected: false,
            liked: false
          };

          result.icon = (() => {
            if (result.isWorkspace) return 'sitemap';
            if (result.isDocument) return 'file';
            if (result.isUser) return 'user';
            if (result.isFolder || result.isList) return 'folder';
            if (result.isNewsFeed) return 'news';
            return '';
          })();

          return result;
        }
      );
    } catch (err) {
      console.log(err);
      return [];
    }
  }

  private static hasProp(obj: any, propName: string): boolean {
    if (propName in obj && obj[propName] != null) {
      return true;
    }
    return false;
  }
}
